<!--<div bsModal #apptModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-event-name">-->
  <div class="modal-dialog modal-lg addNew-training--modal" *ngIf="this.viewType != 'changeAssignee'">
    <div *ngIf="selectedAppt" class="modal-content">
      <div class="modal-header new_modal mb-0 pb-0">
        <h4 id="dialog-event-name" class="modal-title pull-left fs-20">{{submitTrainingViewTitle()}}</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="hideTrainingModal()">
          <i class="fa fa-close"></i>
        </button>
      </div>
      <form (ngSubmit)="addUpdateTraining()">
        <div class="modal-body">
          <div>
            <div class="form-group" *ngIf="selectedAppt.viewType !== 'newTraining'">
              <h4>Trainee Details: {{selectedAppt.training_doctor_partner_type == 'doctor' ? 'Business' :
                selectedAppt.training_doctor_partner_type}}{{selectedAppt.doctor_partner_type}} </h4>
              <div class="row" *ngIf="selectedAppt.training_doctor_partner_type == 'doctor'">
                <div class="col-4">
                  Booked For:<b class="ml-1"> {{bookedByAgent ? ((allEventData?.training_agents?.length || 0) > 1 ? 'Business Users' : 'Business User') : 'Business'}}</b>
                </div>
                <div class="col-4">Name:
                  <span *ngIf="bookedByAgent"><b class="ml-1">{{trainingAgentsText('training_agent_name')}}</b></span>
                  <ng-container *ngIf="!bookedByAgent">
                    <span class="text-muted" *ngIf="selectedAppt.selectedDoctorId!==0">
                      <b class="ml-1"><a [routerLink]="'/app/business/details/'+_shared.encodeId(selectedAppt.selectedDoctorId)"
                          (click)="hideTrainingModal()">{{allEventData?.training_doctor_name  ? allEventData?.training_doctor_name :selectedAppt.selectedDoctor.doctor_name}}</a></b>
                    </span>
                    <span *ngIf="selectedAppt.selectedDoctorId===0"><b
                        class="ml-1">{{allEventData?.training_doctor_name  ? allEventData?.training_doctor_name : selectedAppt.selectedDoctor.doctor_name}}</b></span>
                  </ng-container>
                </div>
                <div class="col-4">Email:
                  <b class="ml-1" style="word-break: break-all">{{bookedByAgent ? trainingAgentsText('training_agent_email') : (allEventData?.training_doctor_email  ? allEventData?.training_doctor_email :selectedAppt.selectedDoctor.doctor_emails)}}</b>
                </div>
                <div class="col-4">
                  Business Name:<b
                    class="ml-1">{{selectedAppt.selectedDoctor.practice_name?selectedAppt.selectedDoctor.practice_name:'N.A.'}}</b>
                </div>
                <div class="col-4">
                  Phone:<b class="ml-1">
                    {{bookedByAgent ? trainingAgentsText('training_agent_phone') : (allEventData?.training_doctor_phone  ? allEventData?.training_doctor_phone : allEventData?.doctor_mobile ? ('+1-' + allEventData?.doctor_mobile) : selectedAppt.selectedDoctor.practice_mobile?(selectedAppt.selectedDoctor.practice_mobile):'N.A.')}}
                  </b>
                </div>
                <div class="col-4" *ngIf="allEventData?.training_doctor_website_link">
                  Website:<b class="ml-1">
                    {{editableUserWebsite || 'N.A.'}}
                  </b>
                </div>
              </div>
              <div class="row" *ngIf="selectedAppt.training_doctor_partner_type == 'partner'">
                <div class="col-4">
                  Booked For:<b class="ml-1"> Partner</b>
                </div>
                <div class="col-4">Name:
                  <span class="text-muted" *ngIf="selectedAppt.selectedDoctorId!==0">
                    <b class="ml-1"><a [routerLink]="'/app/partners/profile/'+selectedAppt.selectedDoctorId"
                        (click)="hideTrainingModal()">
                        {{selectedAppt.selectedDoctor.partner_name || selectedAppt.selectedDoctor.doctor_name}}</a></b>
                  </span>
                  <span *ngIf="selectedAppt.selectedDoctorId===0"><b
                      class="ml-1">{{selectedAppt.selectedDoctor.doctor_name}}</b></span>
                </div>
                <div class="col-4">Email:
                  <b class="ml-1" style="word-break: break-all">{{selectedAppt.selectedDoctor.partner_email ||
                    selectedAppt.selectedDoctor.doctor_emails}}</b>
                </div>
                <div class="col-4">
                  Phone:<b class="ml-1">
                    {{selectedAppt.selectedDoctor.partner_mobile?(selectedAppt.selectedDoctor.partner_mobile):selectedAppt.selectedDoctor.practice_mobile?(selectedAppt.selectedDoctor.practice_mobile):'N.A.'}}
                  </b>
                </div>
              </div>
              <br /><br />
              <h4>Training Info: </h4>
              <div class="row">
                <div class="col-4">
                  Schedule
                  Date:<b class="ml-1">{{selectedAppt.schedule_date}}</b>
                </div>
                <div class="col-4">
                  Schedule Time:<b class="ml-1">{{selectedAppt.schedule_time}}</b>
                </div>
                <!--<div class="col-4">
                    Timezone:<b class="ml-1">{{selectedAppt.offset}}</b>
                  </div>-->
                <div class="col-4">
                  Duration:<b class="ml-1">{{selectedAppt.training_duration + ' mins'}}</b>
                </div>
                <div class="col-4">
                  Type of Training:
                  <b class="ml-1">{{selectedAppt.selectedTrainingObj ? selectedAppt.selectedTrainingObj.name : ''}}</b>
                </div>
                <div class="col-4">
                  Assigned to:
                  <b class="ml-1">{{selectedAppt.excludeAdmin && (selectedAppt.excludeAdmin.admin_name + '
                    ('+selectedAppt.excludeAdmin.admin_email+')')}}</b>
                </div>
                <div class="col-4">
                  Status:
                  <b class="ml-1">{{selectedAppt.training_status_name}}</b>
                </div>
                <div class="col-4" *ngIf="selectedAppt.eventId">
                  <a href="javascript:void(0)" 
                    (click)="hideTrainingModal()">
                    View All Details
                  </a>
                </div>
                <!--<div class="col-4">
                    <a href="javascript:void(0)" [routerLink]="'/app/training/details/'+ _shared.encodeId(selectedAppt.training_id)">
                      View All Details
                    </a>
                  </div>-->
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between" *ngIf="selectedAppt.viewType === 'newTraining'">
              <p class="past-training mb-0">Do you want to book past training ?</p>
              <div class="switch">
                <label>
                  <input class="form-control" type="checkbox" [(ngModel)]="trainingSwitch" name="trainingSwitch">
                  <span class="lever"></span>
                </label>
              </div>
            </div>
            <hr>
            <div class="row align-items-center">
              <div class="col-4 mb-3 form-group"
              *ngIf="selectedAppt.viewType !== 'updateTrainingNotes' && selectedAppt.viewType !== 'newTraining'">
              <label for="status">Status*</label>
              <select name="aptStatus" [(ngModel)]="selectedAppt.status" id="status" class="form-control"
                (change)="trainingStatusChanged()">
                <!--<option value="1">New Registration</option>-->
                <ng-container *ngFor="let trainingStatus of trainingStatusTypes">
                  <option *ngIf="shouldShowOption(trainingStatus.training_status_id, selectedAppt)"
                    [value]="trainingStatus.training_status_id">{{trainingStatus &&
                    trainingStatus.training_status_name}}</option>
                </ng-container>
              </select>
            </div>
              <div class="col-4 mb-3"
                *ngIf="!trainingSwitch && (selectedAppt.viewType === 'newTraining' || selectedAppt.viewType === 'editTraining')">
                <div class="form-group">
                  <label>Schedule Date : </label>
                  <input class="form-control datepicker_field" name="aptDate" [(ngModel)]="selectedAppt.date" bsDatepicker
                    (ngModelChange)="trainingDateChanged()" [minDate]="getMinDate()" type='text' readonly
                    (keydown)="disableKeyDown($event)" [bsConfig]="{  containerClass: 'theme-blue' }" />
                </div>
              </div>
              <div class="col-4 mb-3" *ngIf="trainingSwitch">
                <div class="form-group">
                  <label>Schedule Date : </label>
                  <input class="form-control datepicker_field" name="selectedAppt.date" [(ngModel)]="selectedAppt.date"
                    bsDatepicker [maxDate]="getPastMinDate()" type='text' readonly
                    [bsConfig]="{  containerClass: 'theme-blue' }" />
                </div>
              </div>
              <!--<div class="col-4">
                  <label for="">Time*</label>
                  <timepicker required [(ngModel)]="selectedAppt.time" #aptTime="ngModel" name="aptTime"></timepicker>
                </div>-->
              <div class="col-4 mb-3"
                *ngIf="selectedAppt.viewType === 'newTraining' || selectedAppt.viewType === 'editTraining'">
                <div class="form-group">
                  <label for="">Type of Training*</label>
                  <select required class="form-control" [(ngModel)]="selectedAppt.selectedTraining" name="aptTraining"
                    (change)="onTrainingSelect()">
                    <option *ngFor="let type of selectedAppt.trainingTypes" [value]="type.type_id">{{type.name}}</option>
                  </select>
                </div>
              </div>
              <!-- <div class="w-100"></div> -->
              <div class="col-4 mb-3 form-group"
                *ngIf="selectedAppt.viewType === 'newTraining' || selectedAppt.viewType === 'editTraining'">
                <label for="timezone">Timezone*</label>
                <select name="aptTimezone" class="form-control" [(ngModel)]="selectedAppt.timezone"
                  (change)="trainingTimezoneChanged()">
                  <option *ngFor="let timezone of timezones" [value]="timezone.code+'****'+timezone.tzOffset">
                    {{timezone.name}} (GMT{{timezone.timezoneString}})</option>
                </select>
              </div>
              <div class="col-4 mb-3 form-group"
                *ngIf="!trainingSwitch && (selectedAppt.viewType === 'newTraining' || selectedAppt.viewType === 'editTraining')">
                <label for="timezone">Training Duration*</label>
                <select name="aptDuration" class="form-control" [(ngModel)]="selectedAppt.trainingDuration"
                  (change)="trainingDurationChanged()">
                  <option *ngFor="let trainingDuration of trainingDurations" [value]="trainingDuration">
                    {{trainingDuration}} Minutes</option>
                </select>
              </div>
              <div class="col-4 mb-3 form-group"
                *ngIf="trainingSwitch && (selectedAppt.viewType === 'newTraining' || selectedAppt.viewType === 'editTraining')">
                <label for="timezone">Training Duration*</label>
                <select name="aptDuration" class="form-control" [(ngModel)]="selectedAppt.trainingDuration">
                  <option *ngFor="let trainingDuration of trainingDurations" [value]="trainingDuration">
                    {{trainingDuration}} Minutes</option>
                </select>
              </div>
             
              <div class="col-4 mb-3 form-group"
              *ngIf="selectedAppt.viewType !== 'updateTrainingNotes'
                && selectedAppt.viewType !== 'newTraining'
                && (selectedAppt.status == 4 || selectedAppt.status == 9 || selectedAppt.status == 6)">

                <label>Follow Up<span *ngIf="selectedAppt.status == 4 || selectedAppt.status == 9">*</span></label>

              <p-calendar
                inputId="followupDate"
                [(ngModel)]="displayedFollowupDate"
                name="followupDate"
                [readonlyInput]="true"
                placeholder="Date and time"
                dateFormat="mm-dd-yy"
                [showTime]="true"
                hourFormat="24"
                [minDate]="followupMinDate"
                [showClear]="true"
                hideOnDateTimeSelect="true">
              </p-calendar>
            
            </div>

            <!-- <div class="col-4 mb-3 form-group"
            *ngIf="selectedAppt.viewType !== 'updateTrainingNotes' && selectedAppt.viewType !== 'newTraining' && (selectedAppt.status == 4 || selectedAppt.status == 9 || selectedAppt.status == 2)">
            <label for="">Follow Ups*</label>
            <div class="input-group">
              <input required [(ngModel)]="selectedAppt.followup_date" name="followupDate" class="form-control"
                bsDatepicker readonly #dp="bsDatepicker" [bsConfig]="dateConfig" [minDate]="today"
                style="background: #ffffff;" placeholder="Choose a date" time>

              <div class="input-group-append">
                <button type="button" (click)="dp.toggle()" class="btn rounded"><i
                    class="fa fa-calendar"></i></button>
              </div>
            </div>
          </div> -->
                      <!-- Training User Name -->
                      <div class="col-4 mb-3 form-group"
                      *ngIf="(selectedAppt.viewType !== 'updateTrainingNotes' || selectedAppt.viewType === 'editTraining') 
                            && (selectedAppt.status == 4 || selectedAppt.status == 3 || selectedAppt.status == 2) && !isAgentTrainingEdit">
                      <label>Training User Name</label>
                      <input type="text" 
                          class="form-control" 
                          [(ngModel)]="editableUserName"
                          name="userName"
                          (ngModelChange)="editBusinessDetail($event, 1)">

                          <p class="text-danger mt-1 fs-12"  style="bottom:-24px"
                          *ngIf="!editableUserName">
                          Training user name is required
                        </p>
                      </div>

                      <!-- Training User Email -->
                      <div class="col-4 mb-3 form-group"
                      *ngIf="(selectedAppt.viewType !== 'updateTrainingNotes' || selectedAppt.viewType === 'editTraining') 
                             && (selectedAppt.status == 4 || selectedAppt.status == 3 || selectedAppt.status == 2) && !isAgentTrainingEdit">
                 
                   <label>Training User Email</label>
                 
                   <input type="email"
                          class="form-control"
                          [(ngModel)]="editableUserEmail"
                          name="userEmail">
                 
                   <!-- Email error -->
                   <p class="text-danger mt-1 fs-12"
                      *ngIf="editableUserEmail && !emailPattern.test(editableUserEmail)">
                      Please enter a valid email address.
                   </p>
                   <p class="text-danger mt-1 fs-12" style="bottom:-24px"
                   *ngIf="!editableUserEmail">
                   Training user email is required
                 </p>
                 
                      </div>

                      <!-- Training User Contact -->
                      <div class="col-4 mb-3 form-group"
                      *ngIf="(selectedAppt.viewType !== 'updateTrainingNotes' || selectedAppt.viewType === 'editTraining') 
                             && (selectedAppt.status == 4 || selectedAppt.status == 3 || selectedAppt.status == 2) && !isAgentTrainingEdit">
                 
                   <label>Training User Contact</label>
                 
                         <input type="text"
                          class="form-control"
                          [(ngModel)]="editableUserPhone"
                          name="userContact"
                          (input)="onPhoneInput()"
                          (keydown)="allowOnlyNumbers($event)"
                          maxlength="13">   

                          <p class="text-danger mt-1 fs-12"
                          *ngIf="editableUserPhone && !phonePattern.test(editableUserPhone)">
                          Please enter a valid contact number
                          </p>  
                          <p class="text-danger mt-1 fs-12" style="bottom:-24px"*ngIf="!editableUserPhone">
                          Training user contact is required
                          </p>              
                 </div>
               

                      <!-- Business-user training: the users attending (add / remove) and each one's
                           Name / Email / Contact for this training -->
                      <ng-container *ngIf="isAgentTrainingEdit && selectedAppt.viewType !== 'updateTrainingNotes'
                             && (selectedAppt.status == 4 || selectedAppt.status == 3 || selectedAppt.status == 2)">
                        <div class="col-12 mb-3 form-group">
                          <label>Business User(s)*</label>
                          <ngx-select [multiple]="true" [items]="selectedAppt.businessUsers" optionValueField="agent_id"
                            optionTextField="agent_name" [allowClear]="true" [autoClearSearch]="true"
                            name="trainingSelectedAgents" [(ngModel)]="selectedAppt.selectedAgentIds"
                            (ngModelChange)="selectedAgentsChanged()" placeholder="Select business user(s)">
                            <ng-template ngx-select-option let-option>
                              <h5 class="m-0">{{option.data.agent_name}}</h5>
                              <small class="m-0">{{option.data.agent_email}}</small>
                            </ng-template>
                            <ng-template ngx-select-option-not-found>
                              No business users found for this business
                            </ng-template>
                          </ngx-select>
                          <p class="text-danger mt-1 fs-12" *ngIf="!selectedAppt.selectedAgentIds?.length">
                            Please select at least one business user
                          </p>
                        </div>
                        <ng-container *ngFor="let row of selectedAppt.agentDetails; let i = index">
                          <div class="col-4 mb-3 form-group">
                            <label>Training User Name<span *ngIf="i === 0 && selectedAppt.agentDetails.length > 1"> (Primary)</span></label>
                            <input type="text" class="form-control" [(ngModel)]="row.training_agent_name"
                              [name]="'agentName' + row.agent_id">
                            <p class="text-danger mt-1 fs-12" *ngIf="!row.training_agent_name?.trim()">
                              Training user name is required
                            </p>
                          </div>
                          <div class="col-4 mb-3 form-group">
                            <label>Training User Email</label>
                            <input type="email" class="form-control" [(ngModel)]="row.training_agent_email"
                              [name]="'agentEmail' + row.agent_id">
                            <p class="text-danger mt-1 fs-12"
                              *ngIf="row.training_agent_email && !emailPattern.test(row.training_agent_email)">
                              Please enter a valid email address.
                            </p>
                            <p class="text-danger mt-1 fs-12" *ngIf="!row.training_agent_email">
                              Training user email is required
                            </p>
                          </div>
                          <div class="col-4 mb-3 form-group">
                            <label>Training User Contact</label>
                            <input type="text" class="form-control" [(ngModel)]="row.training_agent_phone"
                              [name]="'agentPhone' + row.agent_id" (input)="onAgentPhoneInput(row)"
                              (keydown)="allowOnlyNumbers($event)" maxlength="13">
                            <p class="text-danger mt-1 fs-12"
                              *ngIf="row.training_agent_phone && !phonePattern.test(row.training_agent_phone)">
                              Please enter a valid contact number
                            </p>
                          </div>
                        </ng-container>
                      </ng-container>

                      <!-- Training User Website -->
                      <!-- <div class="col-4 mb-3 form-group"
                    *ngIf="(selectedAppt.viewType !== 'updateTrainingNotes' || selectedAppt.viewType === 'editTraining') 
                            && (selectedAppt.status == 4 || selectedAppt.status == 3 || selectedAppt.status == 2) && !isAgentTrainingEdit">

                  <label>Training User Website</label>

                  <input type="text"
                        class="form-control"
                        [(ngModel)]="editableUserWebsite"
                        name="userWebsite"
                        required
                        (input)="handleWebsite()"
                        placeholder="Enter your website URL"
                        #userWebsite="ngModel">

                  <p class="text-danger mt-1 fs-12 mb-1"
                    *ngIf="editableUserWebsite && !isWebsiteValid">
                    Please enter a valid website URL (example: https://example.com)
                  </p>

                </div> -->
                 <!-- <div class="col-4 mb-3 form-group"
                *ngIf="selectedAppt.viewType !== 'updateTrainingNotes' && selectedAppt.viewType !== 'newTraining' && (selectedAppt.status == 5)">
                <label for="">Completed*</label>
                <div class="input-group">
                  <input required [(ngModel)]="selectedAppt.followup_date" name="followupDate" class="form-control"
                    bsDatepicker readonly #dp="bsDatepicker" [bsConfig]="dateConfig" [minDate]="today"
                    style="background: #ffffff;" placeholder="Choose a date">
                  <div class="input-group-append">
                    <button type="button" (click)="dp.toggle()" class="btn rounded"><i
                        class="fa fa-calendar"></i></button>
                  </div>
                </div>
              </div> -->
              <div class="col-4 mb-3 form-group checkbox c-checkbox mt-4"
                *ngIf="!trainingSwitch && (selectedAppt.status=='2' || selectedAppt.status=='7')">
                <span class="position-relative">
                  <input
                  class="secondary-checkbox"
                  #sendEmailCheckbox
                  [(ngModel)]="selectedAppt.send_email"
                  name="sendEmail"
                  type="checkbox"
                  id="sendEmail"
                  (change)="sendEmail($event)"
                >
                  <label class="fs-14 fw-400 m-0" for="sendEmail"></label>Send Email
                </span>
              </div>
            </div>
  
            <div class="w-100"></div>
            <div class="row align-items-center form-group"
              *ngIf="!trainingSwitch && (selectedAppt.viewType === 'newTraining' || selectedAppt.viewType === 'editTraining')">
              <div class="col-12">Select Training Time*</div>
              <div class="col-12 no_available_time_error" *ngIf="!selectedAppt.availableStartTimes.length">No slots
                available for selected date.</div>
              <div class="col-2" *ngFor="let availableStartTime of selectedAppt.availableStartTimes; let i = index;">
                <button type="button" class="btn available_start_time"
                  [ngClass]="selectedAppt.selectedAvailableStartTime ? selectedAppt.selectedAvailableStartTime.timeAmPm ===  availableStartTime.timeAmPm ? 'btn-primary' : 'btn-outline-secondary' : 'btn-outline-secondary'"
                  (click)="selectTrainingTime(availableStartTime)">{{availableStartTime.timeAmPm}}</button>
              </div>
            </div>
            <div class="row align-items-center form-group" *ngIf="trainingSwitch ">
              <div class="col-12">Select Training Time*</div><br>
              <div class="col-6 past-hours">
                <ngx-select [items]="hours" optionValueField="value" optionTextField="value" name="value"
                  [allowClear]="false" placeholder="HH" [(ngModel)]="pastTrainingTime.hour">
                  <ng-template ngx-select-option-selected let-option>
                    {{option.data.value}}
                  </ng-template>
                  <ng-template ngx-select-option-not-found>
                    Not found
                  </ng-template>
                </ngx-select>
              </div>
              <div class="col-6">
                <ngx-select [items]="minutes" optionValueField="value" optionTextField="value" name="value"
                  [allowClear]="false" placeholder="MM" [(ngModel)]="pastTrainingTime.minutes">
                  <ng-template ngx-select-option-selected let-option>
                    {{option.data.value}}
                  </ng-template>
                  <ng-template ngx-select-option-not-found>
                    Not found
                  </ng-template>
                </ngx-select>
              </div>
            </div>
  
            <div class="row align-items-center"
              *ngIf="selectedAppt.viewType === 'newTraining' || selectedAppt.viewType === 'editTraining'">
              <div class="col-4 form-group" *ngIf="selectedAppt.availableAdminUsers.length">
                <div class="form-group">
                  <label>CSR Name*</label>
                  <ngx-select [items]="selectedAppt.availableAdminUsers" optionValueField="admin_id"
                    optionTextField="admin_name" [allowClear]="true" (select)="selectApptAdmin()"
                    (typed)="fetchAvailableAdminList($event)" name="selectedAdmin"
                    [(ngModel)]="selectedAppt.selectedAdminId" [placeholder]="'Select CSR'"
                    [disabled]="selectedAppt.assign_automatic">
                    <ng-template ngx-select-option-selected let-option>
                      {{option.data.admin_name + ' ('+option.data.admin_email+')'}}
                    </ng-template>
                    <ng-template ngx-select-option let-option let-text="text">
                      {{option.data.admin_name}} <br>
                      <small>{{option.data.admin_email}}</small>
                    </ng-template>
                    <ng-template ngx-select-option-not-found>
                      Not found
                    </ng-template>
                  </ngx-select>
                </div>
              </div>
              <div class="mt-1 col-4" *ngIf="selectedAppt.availableAdminUsers.length">
                <span>
                  <input class="secondary-checkbox" #assign_automatic [(ngModel)]="selectedAppt.assign_automatic"
                    name="assign_automatic" type="checkbox" (ngModelChange)="assignAutomaticChanged()"
                    id="assign_automatic" />
                  <label class="fs-14 fw-400 m-0" style="padding-top: 15px;" for="assign_automatic"></label>Assign Automatically
                </span>
              </div>
            </div>
  
            <div class="w-100"></div>
            <div class="row align-items-center form-group" *ngIf="selectedAppt.viewType === 'newTraining'">
  
              <div class="col-8">
                <label class="mt-4">Book Training For</label>
                <div class="d-flex align-items-center mt-2 gap-4">
                  <!-- Both options book a business training (training_doctor_partner_type stays 'doctor'):
                       for the business owner, or for one or more of its registered users -->
                  <span class="position-relative">
                    <input class="secondary-radio"
                      [(ngModel)]="selectedAppt.book_for" (ngModelChange)="bookForChanged()"
                      name="book_for" type="radio" value="business" id="book_for_business">
                    <label class="fs-14 fw-400 m-0" for="book_for_business"></label>Business
                  </span>
                  <span class="position-relative">
                    <input class="secondary-radio"
                      [(ngModel)]="selectedAppt.book_for" (ngModelChange)="bookForChanged()"
                      name="book_for" type="radio" value="business_user" id="book_for_business_user">
                    <label class="fs-14 fw-400 m-0" for="book_for_business_user"></label>Business Users
                  </span>
                  <!-- <span class="position-relative">
                    <input class="secondary-radio" name="training_doctor_partner_type"
                      [(ngModel)]="selectedAppt.training_doctor_partner_type" type="radio" value="partner"
                      (ngModelChange)="resetTraineeSelection()" id="training_doctor_partner_type">
                    <label class="fs-14 fw-400 m-0" for="training_doctor_partner_type"></label>Partner
                  </span> -->
                </div>
              </div>
              <div class="w-100"></div>
              <!-- business users exist only for registered businesses -->
              <div class="col-4" *ngIf="!trainingSwitch && selectedAppt.book_for !== 'business_user'">
                <div class="mt-1">
                  <span class="position-relative">
                    <input class="secondary-checkbox" #out_of_system [(ngModel)]="selectedAppt.out_of_system"
                      name="out_of_system" type="checkbox" (ngModelChange)="outOfSystemChanged()" id="out_of_system" />
                    <label class="fs-14 fw-400 m-0" for="out_of_system"></label>Unregistered <i
                      class="fa fa-info-circle mt-1" data-container="body" data-placement="top"
                      tooltip="Please select this option to schedule training for unregistered Business"></i>
                  </span>
                </div>
              </div>
              <div class="w-100"></div>
              <div class="col-12 pl-0" *ngIf="!selectedAppt.out_of_system">
                <div class="col-6" *ngIf="selectedAppt.training_doctor_partner_type == 'doctor'">
                  <div class="form-group doctor-select-wrap">
                    <label>Business Name*</label>
                    <ngx-select [items]="doctorDropdownItems" optionValueField="doctor_id" optionTextField="doctor_name"
                      [allowClear]="false" (select)="selectTrainingDoctor($event)" (typed)="fetchDoctorList($event)"
                      [searchCallback]="doctorSearchCallback"
                      name="trainingSelectedDoctor" [(ngModel)]="selectedAppt.selectedDoctorId" readonly>
                      <ng-template ngx-select-option-selected let-option>
                        {{option.data.practice_name?option.data.practice_name:'-'}}
                      </ng-template>
                      <ng-template ngx-select-option let-option let-text="text">
                        <ng-container *ngIf="option.data.isSkeleton">
                          <span class="doctor-skeleton doctor-skeleton--name"></span>
                          <span class="doctor-skeleton doctor-skeleton--line"></span>
                        </ng-container>
                        <ng-container *ngIf="!option.data.isSkeleton">
                          <h5 class="m-0">{{option.data.doctor_name}}</h5>
                          <small class="m-0">
                            Business: {{option.data.practice_name}} | Email: {{option.data.doctor_email ? option.data.doctor_email :option.data.doctor_emails}}
                          </small>
                        </ng-container>
                      </ng-template>
                      <ng-template ngx-select-option-not-found>
                        Not found
                      </ng-template>
                    </ngx-select>
                  </div>
                </div>
                <div class="col-6"
                  *ngIf="selectedAppt.book_for === 'business_user' && selectedAppt.training_doctor_partner_type == 'doctor' && selectedAppt.selectedDoctorId">
                  <div class="form-group">
                    <label>Business User(s)*</label>
                    <ngx-select [multiple]="true" [items]="selectedAppt.businessUsers" optionValueField="agent_id"
                      optionTextField="agent_name" [allowClear]="true" [autoClearSearch]="true"
                      [showOptionNotFoundForEmptyItems]="true"
                      name="trainingSelectedAgents" [(ngModel)]="selectedAppt.selectedAgentIds"
                      placeholder="Select business user(s)">
                      <ng-template ngx-select-option let-option>
                        <h5 class="m-0">{{option.data.agent_name}}</h5>
                        <small class="m-0">{{option.data.agent_email}}</small>
                      </ng-template>
                      <ng-template ngx-select-option-not-found>
                        No users
                      </ng-template>
                    </ngx-select>
                  </div>
                </div>
                <div class="col-6" *ngIf="selectedAppt.training_doctor_partner_type == 'partner'">
                  <div class="form-group doctor-select-wrap">
                    <label>Partner Name*</label>
                    <ngx-select [items]="doctorDropdownItems" optionValueField="partner_id"
                      optionTextField="partner_name" [allowClear]="false" (select)="selectTrainingDoctor($event)"
                      (typed)="fetchDoctorList($event)" name="trainingSelectedDoctor"
                      [searchCallback]="doctorSearchCallback"
                      [(ngModel)]="selectedAppt.selectedDoctorId" readonly>
                      <ng-template ngx-select-option-selected let-option>
                        {{option.data.partner_name?option.data.partner_name:'-'}}
                      </ng-template>
                      <ng-template ngx-select-option let-option let-text="text">
                        <ng-container *ngIf="option.data.isSkeleton">
                          <span class="doctor-skeleton doctor-skeleton--name"></span>
                          <span class="doctor-skeleton doctor-skeleton--line"></span>
                        </ng-container>
                        <ng-container *ngIf="!option.data.isSkeleton">
                          <h5 class="m-0">{{option.data.partner_name}}</h5>
                          <small class="m-0">
                            {{option.data.partner_email}}
                          </small>
                        </ng-container>
                      </ng-template>
                      <ng-template ngx-select-option-not-found>
                        Not found
                      </ng-template>
                    </ngx-select>
                  </div>
                </div>
              </div>
  
              <div class="col-6"
                *ngIf="selectedAppt.out_of_system && selectedAppt.training_doctor_partner_type == 'doctor'">
                <div class="form-group">
                  <label>Business Name</label>
                  <input type="text" class="form-control" [(ngModel)]="selectedAppt.selectedDoctor.practice_name" practice
                    name="aptPracticeName">
                  <p class="text-danger"
                    *ngIf="selectedAppt.out_of_system && (selectedAppt.selectedDoctor.practice_name ? selectedAppt.selectedDoctor.practice_name.length > 256 : false)">
                    Please enter valid Business name.
                  </p>
                </div>
              </div>
              <!--<span *ngIf="!selectedAppt.out_of_system && selectedAppt.selectedDoctor ">-->
              <div class="col-6"
                *ngIf="(!selectedAppt.out_of_system && selectedAppt.selectedDoctor) || selectedAppt.out_of_system">
                <div class="form-group">
                  <label for="">Contact Name*</label>
                  <input  [disabled]="!selectedAppt.out_of_system ? selectedAppt.isDoctorPrefilled : !selectedAppt.out_of_system" type="text" class="form-control" contact
                    [(ngModel)]="selectedAppt.selectedDoctor.doctor_name" name="aptContactName" trim="true">
                    <p class="text-danger"
                      *ngIf="
                        (selectedAppt.out_of_system || !selectedAppt.isDoctorPrefilled) &&
                        (
                          !selectedAppt.selectedDoctor?.doctor_name ||
                          selectedAppt.selectedDoctor.doctor_name.length > 256
                        )
                      ">
                      Please enter valid contact name.
                    </p>
                </div>
              </div>
              <div class="col-6"
                *ngIf="(!selectedAppt.out_of_system && selectedAppt.selectedDoctor) || selectedAppt.out_of_system">
                <div class="form-group">
                  <label for="">Phone Number</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <select name="mobile_code" class="input-group-text p-1" [(ngModel)]="selectedMobileCode"
                        (change)="changeMobileCode(selectedMobileCode)">
                        <option *ngFor="let option of mobile_code_arr; let i =index" [value]="option">
                          <span>{{option}}</span>
                        </option>
                      </select>
                    </div>
                    <input  [disabled]="!selectedAppt.out_of_system ? selectedAppt.isDoctorPrefilled : !selectedAppt.out_of_system" phone type="text" class="form-control"
                      [(ngModel)]="selectedAppt.selectedDoctor.doctor_mobile" name="aptPhone" maxlength="10" />
                  </div>
                  <p class="text-danger"
                  *ngIf="
                    (selectedAppt.out_of_system || !selectedAppt.isDoctorPrefilled) &&
                    selectedAppt.selectedDoctor?.doctor_mobile &&
                    !isPhoneNumberValid(selectedAppt.selectedDoctor.doctor_mobile)
                  ">
                  Please enter a valid phone number.
                </p>
                </div>
              </div>
              <div class="col-6"
                *ngIf="(!selectedAppt.out_of_system && selectedAppt.selectedDoctor) || selectedAppt.out_of_system">
                <div class="form-group">
                  <label for="">Email Address*</label>
                  <input [disabled]="!selectedAppt.out_of_system" type="text" email name="aptEmail" class="form-control"
                    [(ngModel)]="selectedAppt.selectedDoctor.doctor_emails" />
                  <p class="text-danger" style="bottom: -24px;"
                    *ngIf="selectedAppt.out_of_system && (!selectedAppt.selectedDoctor.doctor_emails || !isValidEmail(selectedAppt.selectedDoctor.doctor_emails))">
                    Please enter a valid email.
                  </p>
                </div>
              </div>
              <!--</span>-->
              <!--<div class ="col-12" *ngIf="selectedAppt.out_of_system">
                    <div class="form-group">
                      <label>Enter Email (Press enter to add):</label>
                      <input type="text" class="form-control" email [(ngModel)]="doctor_emails" #cEmail="ngModel" name="cEmail"
                      (keyup.enter)="addEmails($event,addAppointmentForm)" trim="blur" />
                      <p class="text-danger" *ngIf="cEmail.invalid && (cEmail.dirty || cEmail.touched)">Please enter a valid email.
                      </p>
                    </div>
                    <div>
                      <label *ngIf="doctorEmails && doctorEmails.length > 0">Selected Emails: </label>
                      <h3>
                        <span class="ml-1 badge text-large badge-primary" *ngFor="let email of doctorEmails">{{email}}
                          &nbsp;<i class="fa fa-close" tappable (click)="removeEmail(email)"></i>
                        </span>
                      </h3>
                      <label *ngIf="!doctorEmails || doctorEmails.length == 0">No Email added yet</label>
                    </div>
                  </div>-->
            </div>
            <div class="row align-items-center form-group"
              *ngIf="selectedAppt.viewType === 'newTraining' || selectedAppt.viewType === 'editTraining'">
              <div class="col-6">
                <div class="form-group">
                  <label for="">Meeting Link</label>
                  <input type="text" name="aptMeetingLink" class="form-control"
                    [(ngModel)]="selectedAppt.trainingMeetingLink" />
                  <p class="text-danger"
                    *ngIf="(selectedAppt.trainingMeetingLink && !isValidUrl(selectedAppt.trainingMeetingLink))">Please
                    enter a valid link.
                  </p>
                </div>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-12 form-group">
                <label for="note">Note*</label>
                <textarea name="aptNote" required [(ngModel)]="selectedAppt.trainingNote" id="" cols="30" rows="4"
                  class="form-control"></textarea>
              </div>
            </div>
            <div class="row align-items-center"
              *ngIf="selectedAppt.viewType === 'editTraining' || selectedAppt.viewType === 'updateTrainingStatus' || selectedAppt.viewType === 'updateTrainingNotes'">
              <div class="col-12 form-group" style="margin-bottom: 1.3rem;">
                <label class="d-block mb-2">Attachments</label>
                <div class="d-flex flex-wrap mb-2" style="gap: 8px;" *ngIf="existingDocs.length">
                  <div *ngFor="let doc of existingDocs; let i = index" class="d-flex align-items-center border rounded px-2 py-1">
                    <a [href]="doc.file_url" target="_blank" class="me-2">View</a>
                    <i class="fa fa-trash attachment-remove-icon" tappable tooltip="Remove attachment"
                      (click)="removeExistingDoc(i)"></i>
                  </div>
                </div>
                <div class="mb-2">
                  <label for="trainingAttachments" class="btn btn-primary btn-sm rounded">Attach Image/Document</label>
                  <input type="file" id="trainingAttachments" #trainingAttachmentInput
                    accept=".gif, .jpeg, .jpg, .png, .doc,.docx,application/msword, .pdf, .xls,.xlsx, .csv"
                    (change)="fileSelect($event)" class="d-none">
                </div>
                <div *ngFor="let file of attachmentImages; let i=index">
                  <div *ngIf="file.subs && file.subs[0]">
                    <div class="d-flex" *ngIf="file.subs[0].message">
                      <progressbar [value]="file.subs[0].message" type="warning" [striped]="true">
                        {{file.subs[0].message}}%</progressbar>
                      <i class="fa fa-close ml-2" tappable tooltip="Cancel upload"
                        (click)="cancelAttachmentUpload(i)"></i>
                    </div>
                    <div *ngIf="file.subs[0].images && file.subs[0].images[0]"
                      class="d-flex justify-content-between align-items-center border mb-1">
                      <span class="p-1">
                        <i class="fa fa-trash attachment-remove-icon me-2" (click)="removeUploadedAttachment(i)"
                          tooltip="Remove uploaded file" tappable></i>
                        <a [href]="file.image" target="_blank">Click here to view</a>
                      </span>
                      <i class="fa fa-check text-success" tooltip="File Uploaded"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--<div class="row align-items-center">

                </div>-->
          </div>
  
        </div>
        <div class="modal-footer">
          <div class="d-flex">
            <div class="text-right">
              <button type="submit" [disabled]="!enableDisableSubmitTrainingButton()"
                class="btn btn-primary">{{submitTrainingButtonTitle()}}</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!--</div>-->

  <!-- change changeAssignee modal -->
<div class="modal-dialog modal-lg" *ngIf="this.viewType === 'changeAssignee'">

  <div class="modal-content" style="border: none;">

    <div class="modal-header bg-primary d-flex justify-content-between">
      <h4 class="modal-title fs-20">Change Assignee</h4>
      <img src="assets/images/icons/white-cross.svg" alt="" class="cursor hw-24" aria-label="Close"
        (click)="hideTrainingModal()">
    </div>

    <div class="modal-body">
      <span class="fs-14 mb-2 fw-500">Select Support Agent</span>
      <div class="col-4 form-group" *ngIf="selectedAppt?.availableAdminUsers?.length; else noSlots">
        <div class="form-group">
          <!-- <label>CSR Name*</label> -->
          <ngx-select [items]="selectedAppt.availableAdminUsers" optionValueField="admin_id"
            optionTextField="admin_name" [allowClear]="true" (select)="selectApptAdmin()"
            (typed)="fetchAvailableAdminList($event)" name="selectedAdmin" [(ngModel)]="selectedAppt.selectedAdminId"
            [placeholder]="'Select CSR'" [disabled]="selectedAppt.assign_automatic">
            <ng-template ngx-select-option-selected let-option>
              {{option.data.admin_name + ' ('+option.data.admin_email+')'}}
            </ng-template>
            <ng-template ngx-select-option let-option let-text="text">
              {{option.data.admin_name}} <br>
              <small>{{option.data.admin_email}}</small>
            </ng-template>
            <ng-template ngx-select-option-not-found>
              Not found
            </ng-template>
          </ngx-select>
        </div>
      </div>

      <ng-template #noSlots>
        <input type="text" class="form-control mb-2" placeholder="No support agent available" disabled>
        <p class="text-danger fs-14 fw-500 mt-2">
          No support agent is available for this time slot. You can edit or reschedule the training.
        </p>
      </ng-template>
      <div class="col-12 form-group mt-2">
        <label for="note">Note*</label>
        <textarea name="aptNote" required [ngModel]="selectedAppt?.trainingNote"
          (ngModelChange)="selectedAppt.trainingNote = $event" id="" cols="30" rows="4" class="form-control"></textarea>
      </div>
    </div>

    <div class="modal-footer">
      <button *ngIf="selectedAppt?.availableAdminUsers?.length" type="button" class="btn btn-primary" (click)="changeScheduledTrainingAssignee()"
        [disabled]="!selectedAppt.selectedAdmin|| !selectedAppt?.trainingNote?.trim()">
        Save
      </button>
      <button *ngIf="!selectedAppt?.availableAdminUsers?.length" type="button" class="btn btn-primary" (click)="editAdmin()">
        Edit
      </button>
      <button type="button" class="btn btn-secondary" (click)="hideTrainingModal()">Cancel</button>
    </div>


  </div>
</div>